import React from 'react';
import { isEmpty } from 'lodash';
import { withRouter } from 'react-router-dom';
import { Translation } from 'react-i18next';
import me3Logo from '../../ASUPhotos/logos/me3_logo_black_NEW.png';

class PageNotFound extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  get hasBeenToDashboard() {
    return this.props.location.state.hasBeenToDashboard;
  }

  get hasPairedThree() {
    return this.props.hasPairedThree;
  }

  get isAuthenticated() {
    return this.props.isAuthenticated;
  }

  get careersHaveBeenSelected() {
    return this.props.careersHaveBeenSelected;
  }

  get hasPlayedGame() {
    return (
      this.props.careerGameResults && !isEmpty(this.props.careerGameResults)
    );
  }

  backToApp = () => {
    if (!this.isAuthenticated)
      return this.props.history.push(
        `/${this.props.tenant.name.toLowerCase()}/landing`
      );
    if (!this.careersHaveBeenSelected && this.hasPlayedGame)
      return this.props.history.push(
        `/${this.props.tenant.name.toLowerCase()}/career-path/top-3`
      );
    if (!this.hasPairedThree && this.careersHaveBeenSelected)
      return this.props.history.push(
        `/${this.props.tenant.name.toLowerCase()}/career-path/path-pairing`
      );
    if (this.hasBeenToDashboard)
      return this.props.history.push(
        `/${this.props.tenant.name.toLowerCase()}/dashboard`
      );
    return this.props.history.push(
      `/${this.props.tenant.name.toLowerCase()}/landing`
    );
  };

  backgroundColorPrimary = {
    backgroundColor: `${this.props.tenant.primary}`,
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <div id="error-page">
            {/* <img className="me3-logo-error" alt="me3 Logo" src={me3Logo} /> */}
            <picture>
              <source
                media="(max-width: 799px)"
                srcset={me3Logo}
                width="480"
                height="400"
              />
              <source
                media="(min-width: 800px)"
                srcset={me3Logo}
                width="800"
                height="400"
              />
              <img
                className="me3-logo-error"
                alt="me3 Logo"
                src={me3Logo}
                width="800"
                height="400"
              />
            </picture>
            <span className="oops">
              {`404: ${t('Page Not Found', {
                context: 'Technical',
              })}`}
            </span>
            <button
              type="button"
              tabIndex={0}
              className="button--primary"
              style={this.backgroundColorPrimary}
              onClick={() => {
                this.backToApp();
              }}
              onKeyDown={(e) => {
                if (['Enter'].includes(e.key)) this.backToApp();
              }}
            >
              {t('Back to the App')}
            </button>
          </div>
        )}
      </Translation>
    );
  }
}

export default withRouter(PageNotFound);
